<template>
  <div
    v-if="needShow(layout)"
    :key="layout.id + 'subHead'"
    :style="pageLayoutStyle(layout, 0)"
    :class="[
      getPageLayoutStyle(0, layout),
      'pageLayout_id_' + layout.id,
      { pagelayout_full_scroll: layout.options.enableLayoutFullScroll }
    ]"
    :layoutIndex="layout.id"
  >
    <div class="mask" @click="activeHead"></div>
    <page-layout
      v-if="stageData"
      :baseComponent="pageLayoutBaseComponent"
      ref="pageLayout"
      :layout="layout"
      :zoom="zoom"
      :layoutIndex="99999"
      :generalPageLayoutLen="generalPageLayoutLen"
      :id="id"
      :isSelfMode="true"
      :selfStage="stageData"
      :key="layout.id + 'subHead'"
      :isFullScroll="
        (layout.options.positionType === 'relative' || !layout.options.positionType) &&
        (layout.options.enableLayoutFullScroll || pageEnableFullScroll) &&
        ['header', 'footer'].indexOf(layout.options.inDocument) == -1
      "
    />
  </div>
</template>
<script>
// 头部展示组件，纯展示用，不包含任何选中、悬浮、交互等逻辑
import { initPcStageData, initAppStageData } from "@/utils/initUrlQueryData"
import pageLayout from "materials/pageLayout/render/index"
export default {
  name: "page-head",
  components: {
    pageLayout
  },
  props: {
    subHeadPageId: undefined,
    generalPageLayoutLen: Number,
    zoom: Number,
    pageLayoutBaseComponent: undefined,
    pageEnableFullScroll: Boolean,
    ids: undefined,
    pageLayoutList: Array,
    id: undefined
  },
  computed: {
    needShow() {
      return function(layout) {
        let isShow = true
        if (layout.options?.hasOwnProperty("isShow")) {
          isShow = layout.options.isShow
        }
        return isShow
      }
    },
    getPageLayoutStyle() {
      return function(index, layout) {
        return [
          "page-layout-wrapper",
          this.ids.pageLayoutId == index ? "select-active" : "",
          layout?.options?.inDocument === "header" ? "pageLayout-header" : "",
        ]
      }
    },
    pageLayoutStyle() {
      return function(pageLayout, index) {
        const {
          positionType,
          isFixed,
          enableBayWindow,
          bayWidth,
          bayHeight,
          bayStartPosition,
          anchorWidth,
          inDocument,
          enableLayoutFullScroll
        } = pageLayout.options
        let isShowAnchor = inDocument === "anchor"
        let width = "100%"
        let position = enableBayWindow || isFixed || isShowAnchor ? "fixed" : positionType ? positionType : ""
        let zIndex = isShowAnchor ? 10001 : this.pageLayoutList.length - index
        if (enableBayWindow) {
          width = `${bayWidth}px`
        } else if (isShowAnchor) {
          width = `${anchorWidth || 40}px`
        } else if (position === "fixed" || position === "absolute") {
          width = pageLayout.options.isCustomWidth ? pageLayout.options.width ? pageLayout.options.width + pageLayout.options.widthType : "100%" : "100%"
        }
        // width = enableBayWindow ? `${bayWidth}px` : isShowAnchor ? `${anchorWidth || 40}px` : "100%",

        let positionStyle = {}
        if (positionType && (positionType === "fixed" || positionType === "absolute")) {
          zIndex = isShowAnchor ? 10001 : this.pageLayoutList.length + 1
          // 都有定位时 提高头部层级 避免下拉被遮挡
          switch (pageLayout.options.inDocument) {
            case "header": //头部
              zIndex = this.pageLayoutList.length + 2
            default:
          }
          //处理快捷定位后的偏移
          if(pageLayout.options.pxOffset){
            // console.log("pxOffset",pageLayout.options.pxOffset)
            const pxOffset = pageLayout.options.pxOffset
            let top = pageLayout.options.pTop
            let right = pageLayout.options.pRight
            let bottom = pageLayout.options.pBottom
            let left = pageLayout.options.pLeft
            if(pageLayout.options.pTop!== 'auto'){
              if(pxOffset[0] && pxOffset[0] !=='自动'){
                top = `calc(${pageLayout.options.pTop} + ${pxOffset[0]}px)`
              }else if(pxOffset[2] && pxOffset[2] !=='自动'){
                top = `calc(${pageLayout.options.pTop} - ${pxOffset[2]}px)`
              }
              bottom="auto"
            }
            if(pageLayout.options.pRight!== 'auto'){
              if(pxOffset[1] && pxOffset[1] !=='自动'){
                right = `calc(${pageLayout.options.pRight} + ${pxOffset[1]}px)`
              }else if(pxOffset[3] && pxOffset[3] !=='自动'){
                right = `calc(${pageLayout.options.pRight} - ${pxOffset[3]}px)`
              }
              left="auto"
            }
            if(pageLayout.options.pBottom!== 'auto'){
              if(pxOffset[2] && pxOffset[2] !=='自动'){
                bottom = `calc(${pageLayout.options.pBottom} + ${pxOffset[2]}px)`
              }else if(pxOffset[0] && pxOffset[0] !=='自动'){
                bottom = `calc(${pageLayout.options.pBottom} - ${pxOffset[0]}px)`
              }
              top='auto'
            }
            if(pageLayout.options.pLeft!== 'auto'){
              if(pxOffset[3] && pxOffset[3] !=='自动'){
                left = `calc(${pageLayout.options.pLeft} + ${pxOffset[3]}px)`
              }else if(pxOffset[1] && pxOffset[1] !=='自动'){
                left = `calc(${pageLayout.options.pLeft} - ${pxOffset[1]}px)`
              }
              right='auto'
            }
            positionStyle = {
              position: isShowAnchor ? 'absolute':positionType,
              top: top,
              left: left,
              right: right,
              bottom: bottom,
              transform: pageLayout.options.translate ? `translate${pageLayout.options.translate}` : "none"
            }
          }else{
            positionStyle = {
              position:  isShowAnchor ? 'absolute':positionType,
              top: pageLayout.options.pTop,
              left: pageLayout.options.pLeft,
              right: pageLayout.options.pRight,
              bottom: pageLayout.options.pBottom,
              transform: pageLayout.options.translate ? `translate${pageLayout.options.translate}` : "none"
            }
          }
        }

        if ((positionType && positionType === "fixed") || (!positionType && isFixed) || enableBayWindow) {
          switch (pageLayout.options.inDocument) {
            case "none":
              break
            case "header": //头部
            case "footer": //底部
              zIndex = 9999
              break
            default:
          }
        }
        if (this.request_prefix === "bigScreen") {
          return {}
        }
        let boxShadow = ""
        if (pageLayout.options.hasOwnProperty("boxShadowH") && typeof pageLayout.options.boxShadowH !== "undefined") {
          if (Array.isArray(pageLayout.options.boxShadowH)) {
            pageLayout.options.boxShadowH.forEach((item, index) => {
              if (index > 0) {
                boxShadow += ","
              }
              let boxShadowColor = pageLayout.options.boxShadowColor
                ? pageLayout.options.boxShadowColor[index]
                : "rgba(255,255,255,0)"
              boxShadow += `${pageLayout.options.boxShadowH[index]}px ${pageLayout.options.boxShadowV[index]}px ${pageLayout.options.boxShadowBlur[index]}px ${pageLayout.options.boxShadowSpread[index]}px ${boxShadowColor}`
            })
          } else {
            boxShadow += `${pageLayout.options.boxShadowH}px ${pageLayout.options.boxShadowV}px ${
              pageLayout.options.boxShadowBlur
            }px ${pageLayout.options.boxShadowSpread}px ${pageLayout.options.boxShadowColor || "rgba(255,255,255,0)"}`
          }
        }
        zIndex = pageLayout.options.hasOwnProperty("zIndex") ? pageLayout.options.zIndex : zIndex
        const styleObj = {
          ...positionStyle,
          zIndex: zIndex,
          position:  isShowAnchor ? 'absolute':position,
          width: width,
          boxShadow: boxShadow
        }
        // 移动端宽度最多100%
        if(this.request_prefix === "appStage") {
          styleObj.maxWidth = "100%"
        }
        if (
          positionType !== "fixed" &&
          positionType !== "absolute" &&
          (enableLayoutFullScroll || this.pageEnableFullScroll) &&
          !enableBayWindow &&
          ["header", "relativeHeader", "footer", "popover"].indexOf(pageLayout.options.inDocument) == -1
        ) {
          styleObj["minHeight"] = "100vh"
          // styleObj.overflowY = 'auto'
          // styleObj.display = 'flex'
          // styleObj.flexDirection = 'column'
          // styleObj.justifyContent = 'center'
        }
        return styleObj
      }
    },
  },
  data() {
    return {
      layout: {options: {},layout: {rows: []}},
      stageData: {}
    }
  },
  created() {
    this.loadHead(this.subHeadPageId)
  },
  methods: {
    async loadHead(headPageId) {
      // 装载页面头部
      const stageData = this.request_prefix === 'stage' ? await initPcStageData(headPageId, {}, false, true) : await initAppStageData(headPageId, {}, true)
      this.stageData = Object.freeze(stageData)
      this.layout = Object.freeze(stageData?.page?.pageLayoutList[0])
      console.log(stageData)
    },
    activeHead() {
      this.$emit("activeHead")
    }
  }
}
</script>
<style lang="scss">
.mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
}
</style>
